import React from "react";

import { createInfoHSBubble, createInfoTSBubble } from "../../common/wdfunction";

const MapType = 3; //0: GoogleMaps, 1: HereMap, 2: Map4D, 3: Leaflet

//props: twoMap: has 2 maps in 1 page. (diff id, diff ref)

class CarMapLocation extends React.Component {
	componentDidMount() {
		console.log(this.refs);
		if (this.props.location) {
			const lat = this.props.location.lat;
			const lon = this.props.location.lon;
			if (MapType === 0) {
				setTimeout(() => {
					this.initGoogleMap(this.refs, lat, lon);
				}, 1000);
			} else if (MapType === 1) {
				this.initHereMap(lat, lon);
			} else if (MapType === 2) {
				setTimeout(() => {
					this.initMap4D(lat, lon);
				}, 1000);
			} else if (MapType === 3) {
				setTimeout(() => {
					this.initLeafletMap(lat, lon);
				}, 1000);
			}
		}
	}

	componentDidUpdate(props) {
		if (this.props.location && this.props.location !== props.location) {
			const lat = this.props.location.lat;
			const lon = this.props.location.lon;
			if (MapType === 0) {
				this.map?.setCenter({ lat: lat, lng: lon });
				this.circle?.setCenter({ lat: lat, lng: lon });
			} else if (MapType === 1) {
				this.map?.setCenter({ lat: lat, lng: lon });
				this.circle?.setCenter({ lat: lat, lng: lon });
			} else if (MapType === 2) {
				this.map?.panTo({ lat: lat, lng: lon });
				this.circle?.setCenter({ lat: lat, lng: lon });
			} else if (MapType === 3) {
				this.map?.setView([lat, lon]);
				this.circle?.setLatLng([lat, lon]);
			}
		}
	}

	initGoogleMap = (ref, lat, lon) => {
		const map = (this.map = new window.google.maps.Map(document.getElementById(`map${this.props.twoMap}`), {
			draggable: false,
			mapTypeControl: false,
			scrollwheel: false,
			clickableIcons: false,
			streetViewControl: false,
			center: { lat: lat, lng: lon },
			zoom: 15,
			zoomControl: true,
			zoomControlOptions: {
				style: window.google.maps.ZoomControlStyle.SMALL,
			},
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			fullscreenControl: false,
		}));

		const Circle = (this.circle = new google.maps.Circle({
			strokeColor: "gray",
			strokeOpacity: 0.8,
			strokeWeight: 2,
			fillColor: "rgba(0, 0, 0, 0.3)",
			fillOpacity: 0.8,
			map: map,
			center: { lat: lat, lng: lon },
			radius: 300,
			zIndex: 1000,
		}));
	};

	initHereMap = (lat, lon) => {
		const mapHere = (this.circle = new window.H.map.Circle(
			// The central point of the circle
			{ lat: lat, lng: lon },
			// The radius of the circle in meters
			400,
			{
				style: {
					strokeColor: "gray", // Color of the perimeter
					lineWidth: 2,
					fillColor: "rgba(0, 0, 0, 0.3)", // Color of the circle
					opacity: 0.3,
				},
			}
		));
		function addCircleToMap(map) {
			map.addObject(mapHere);
		}
		//Step 1: initialize communication with the platform
		var platform = new window.H.service.Platform({
			useHTTPS: true,
			useCIT: true,
			apikey: "jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc",
		});

		var pixelRatio = window.devicePixelRatio || 1;
		var defaultLayers = platform.createDefaultLayers({
			tileSize: pixelRatio === 1 ? 256 : 512,
			ppi: pixelRatio === 1 ? undefined : 320,
		});

		//Step 2: initialize a map - this map is centered over New Delhi
		var mapContainer = document.getElementById(`map${this.props.twoMap}`),
			routeInstructionsContainer = document.getElementById("panel");
		var defaultLayers = platform.createDefaultLayers();

		var map = (this.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
			center: { lat: lat, lng: lon },
			zoom: 14,
			pixelRatio: window.devicePixelRatio || 1,
		}));

		//Step 3: make the map interactive
		// MapEvents enables the event system
		// Behavior implements default interactions for pan/zoom (also on mobile touch environments)
		var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
		behavior.disable(window.H.mapevents.Behavior.WHEELZOOM);
		behavior.disable(window.H.mapevents.Behavior.DRAGGING);

		// Create the default UI components
		var ui = window.H.ui.UI.createDefault(map, defaultLayers);

		createInfoHSBubble(ui);
		createInfoTSBubble(ui);

		// Now use the map as required...
		addCircleToMap(map);
	};

	initMap4D = (lat, lon) => {
		let map4D = (this.map = new window.map4d.Map(document.getElementById(`map${this.props.twoMap}`), {
			center: { lat: lat, lng: lon },
			zoom: 15,
			controls: false,
		}));
		let circle = (this.circle = new map4d.Circle({
			center: { lat: lat, lng: lon },
			fillColor: "#767676",
			fillOpacity: 0.3,
			radius: 300,
			strokeWidth: 1.0,
			strokeColor: "#767676",
		}));
		circle.setMap(map4D);
	};

	initLeafletMap = (lat, lon) => {
		const map = (this.map = L.map(`map${this.props.twoMap}`, {
			center: [lat, lon],
			zoom: 14,
			dragging: false,
			attributionControl: false,
			// zoomControl: false,
			// doubleClickZoom: false,
			// scrollWheelZoom: false,
		}));

		/* required for rendering map: START */
		L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
			maxZoom: 19,
			noWrap: true,
			attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		}).addTo(map);
		/* required for rendering map: END */

		const circle = (this.circle = L.circle([lat, lon], {
			fillColor: "rgba(0, 0, 0, 0.3)",
			fillOpacity: 0.8,
			color: "gray",
			radius: 500,
		}).addTo(map));
	};

	render() {
		const { mapBox, twoMap } = this.props;
		return (
			<div
				ref={`map${twoMap}`}
				id={`map${twoMap}`}
				className="wrap-map"
				style={mapBox ? { height: "500px", zIndex: 0 } : { zIndex: 0 }}
			/>
		);
	}
}

export default CarMapLocation;
